import { Icon, IconOption, IconSize } from "@kaggle/material";
import styled from "styled-components";
import * as React from "react";

// TODO(b/249614990): Long-term, we should be using the same KM IconButton as
// everywhere else (IconButton from @kaggle/material).

const Body = styled.div<{ disabled?: boolean }>`
  color: ${props => (props.disabled ? "#ccc" : "#b5b6b8")};
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  display: flex;
  flex-flow: column nowrap;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;

interface Props {
  icon: IconOption | IconOption[];
  onClick: () => void;
  style?: React.CSSProperties;
  className?: string;
  title?: string;
  disabled?: boolean;
  size?: IconSize;
}

/** Custom buttons for use in Notebook. */
export const IconButton = React.memo(
  ({
    icon,
    onClick,
    style,
    className,
    title,
    disabled,
    size = "inline",
  }: Props) => (
    <Body
      onClick={disabled ? undefined : onClick}
      style={style}
      className={className}
      title={title}
      disabled={disabled}
    >
      {Array.isArray(icon) ? (
        icon.map(iconName => (
          <Icon key={iconName} icon={iconName} size={size} />
        ))
      ) : (
        <Icon icon={icon} size={size} />
      )}
    </Body>
  )
);
